@if (cards) {
<app-card-deck [cards]="cards" [itemsPerRow]="itemsPerRow"> </app-card-deck>
}
